import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import React, { useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import FeuC16OnShorePowerSupply from './FeuC16OnShorePowerSupply/FeuC16OnShorePowerSupply';
import FeuC17ZeroEmissions from './FeuC17ZeroEmissions/FeuC17ZeroEmissions';
import FeuC22ProcedureMeasurements from './FeuC22FueleuProceduresMeasurements/FeuC22ProcedureMeasurements';
import FeuC23QualityAssurance from './FeuC23QualityAssurance/FeuC23QualityAssurance';
import FeuC21InstrumentsInvolved from './FeuC21InstrumentsInvolved/FeuC21InstrumentsInvolved';
import FeuConditinsOfExemption from "./FeuConditionsOfExemption/FeuConditionsOfExemption";
import FeuC11FuelConsumption from "./FeuC11FuelConsumption/FeuC11FuelConsumption";
import FeuC12FuelBunkered from "./FeuC12FuelBunkered/FeuC12FuelBunkered";
import FeuC31ListOfVoyages from "./FeuC31ListOfVoyages/FeuC31ListOfVoyages";
import FeuC32DistanceTravelled from "./FeuC32DistanceTravelled/FeuC32DistanceTravelled";
import FeuC33DistanceTravelledInIce from "./FeuC33DistanceTravelledInIce/FeuC33DistanceTravelledInIce";
import FeuC18SailingInIce from "./FeuC18SailingInIce/FeuC18SailingInIce";
import FeuC13BunkerQualityCheck from './FeuC13BunkerQuantityCheck/FeuC13BunkerQuantityCheck';
import FeuC14DeterminationOfDensity from './FeuC14DeterminationOfDensity/FeuC14DeterminationOfDensity';
import FeuC15UncertainityLevel from './FeuC15UncertainityLevel/FeuC15UncertainityLevel';
import FeuC34SeaBerthTimeProcedures from './FeuC34SeaBerthTimeProcedures/FeuC34SeaBerthTimeProcedures';

const FeuActivityData = ({ data, refetchMonitoringData, dropdownData,vesselMstId }) => {
	const [expandedMainPanel, setExpandedMainPanel] = useState("parentPanel");
	const [expandedChild, setExpandedChild] = useState(null);

	const renderTitleWithIcon = (panel, title) => (
		<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
			<span style={{ fontSize: "20px", fontWeight: "bold" }}>{expandedMainPanel === panel || expandedChild === panel ? "−" : "+"}</span>
			<p className="fuel-cons">{title}</p>
		</div>
	);

	const autoSaveForC1 = useRef();
	const autoSaveForC = useRef();
	const autoSaveForC11 = useRef();
	const autoSaveForC12 = useRef();
	const autoSaveForC13 = useRef();
	const autoSaveForC14 = useRef();
	const autoSaveForC15 = useRef();
	const autoSaveForC16 = useRef();
	const autoSaveForC17 = useRef();
	const autoSaveForC18 = useRef();
	const autoSaveForC2 = useRef();
	const autoSaveForC21 = useRef();
	const autoSaveForC22 = useRef();
	const autoSaveForC23 = useRef();
	const autoSaveForC3 = useRef();
	const autoSaveForC31 = useRef();
	const autoSaveForC32 = useRef();
	const autoSaveForC33 = useRef();
	const autoSaveForC34 = useRef();

	const handleMainChange = (panel) => async (_, isExpanded) => {
		let isSubmitSuccess = true;
		if (expandedMainPanel === 'parentPanel' && autoSaveForC1.current?.submitAndCheck) {
			isSubmitSuccess = await autoSaveForC1.current.submitAndCheck();
		} else if (expandedMainPanel === 'parentPanel2' && autoSaveForC2.current?.submitAndCheck) {
			isSubmitSuccess = await autoSaveForC2.current.submitAndCheck();
		} else if (expandedMainPanel === 'parentPanel3' && autoSaveForC3.current?.submitAndCheck) {
			isSubmitSuccess = await autoSaveForC3.current.submitAndCheck();
		}

		if (!isSubmitSuccess) return;

		if (expandedChild === 'panel1' && autoSaveForC?.current?.submitAndCheck) {
			const isValid = await autoSaveForC.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel1.1' && autoSaveForC11?.current?.submitAndCheck) {
			const isValid = await autoSaveForC11.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel1.2' && autoSaveForC12?.current?.submitAndCheck) {
			const isValid = await autoSaveForC12.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel1.3' && autoSaveForC13?.current?.submitAndCheck) {
			const isValid = await autoSaveForC13.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel2.6' && autoSaveForC14?.current?.submitAndCheck) {
			const isValid = await autoSaveForC14.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel2.7' && autoSaveForC15?.current?.submitAndCheck) {
			const isValid = await autoSaveForC15.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel1.6' && autoSaveForC16?.current?.submitAndCheck) {
			const isValid = await autoSaveForC16.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel1.7' && autoSaveForC17?.current?.submitAndCheck) {
			const isValid = await autoSaveForC17.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel1.8' && autoSaveForC18?.current?.submitAndCheck) {
			const isValid = await autoSaveForC18.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel2.1' && autoSaveForC21?.current?.submitAndCheck) {
			const isValid = await autoSaveForC21.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel2.2' && autoSaveForC22?.current?.submitAndCheck) {
			const isValid = await autoSaveForC22.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel2.3' && autoSaveForC23?.current?.submitAndCheck) {
			const isValid = await autoSaveForC23.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel3.1' && autoSaveForC31?.current?.submitAndCheck) {
			const isValid = await autoSaveForC31.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel3.2' && autoSaveForC32?.current?.submitAndCheck) {
			const isValid = await autoSaveForC32.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel3.3' && autoSaveForC33?.current?.submitAndCheck) {
			const isValid = await autoSaveForC33.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel3.4' && autoSaveForC34?.current?.submitAndCheck) {
			const isValid = await autoSaveForC34.current.submitAndCheck();
			if (!isValid) return;
		}
		setExpandedMainPanel(isExpanded ? panel : false);
		// if (panel === 'parentPanel') {
		setExpandedChild(null);
		// }
	};

	const handleChildChange = (panel) => async (_, isExpanded) => {
		let isSubmitSuccess = true;
		if (expandedChild === 'panel1' && autoSaveForC?.current?.submitAndCheck) {
			const isValid = await autoSaveForC.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel1.1' && autoSaveForC11?.current?.submitAndCheck) {
			const isValid = await autoSaveForC11.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel1.2' && autoSaveForC12?.current?.submitAndCheck) {
			const isValid = await autoSaveForC12.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel1.3' && autoSaveForC13?.current?.submitAndCheck) {
			const isValid = await autoSaveForC13.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel2.6' && autoSaveForC14?.current?.submitAndCheck) {
			const isValid = await autoSaveForC14.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel2.7' && autoSaveForC15?.current?.submitAndCheck) {
			const isValid = await autoSaveForC15.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel1.6' && autoSaveForC16?.current?.submitAndCheck) {
			const isValid = await autoSaveForC16.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel1.7' && autoSaveForC17?.current?.submitAndCheck) {
			const isValid = await autoSaveForC17.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel1.8' && autoSaveForC18?.current?.submitAndCheck) {
			const isValid = await autoSaveForC18.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel2.1' && autoSaveForC21?.current?.submitAndCheck) {
			const isValid = await autoSaveForC21.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel2.2' && autoSaveForC22?.current?.submitAndCheck) {
			const isValid = await autoSaveForC22.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel2.3' && autoSaveForC23?.current?.submitAndCheck) {
			const isValid = await autoSaveForC23.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel3.1' && autoSaveForC31?.current?.submitAndCheck) {
			const isValid = await autoSaveForC31.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel3.2' && autoSaveForC32?.current?.submitAndCheck) {
			const isValid = await autoSaveForC32.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel3.3' && autoSaveForC33?.current?.submitAndCheck) {
			const isValid = await autoSaveForC33.current.submitAndCheck();
			if (!isValid) return;
		} else if (expandedChild === 'panel3.4' && autoSaveForC34?.current?.submitAndCheck) {
			const isValid = await autoSaveForC34.current.submitAndCheck();
			if (!isValid) return;
		}
		if (!isSubmitSuccess) return;
		setExpandedChild(isExpanded ? panel : null);
	};


	const methods = useForm({
		mode: "onBlur",
		defaultValues: {
			NameOfTheShip: "",
		},
	});
	
	return (
		<div>
			<FormProvider {...methods}>
				<form className="activity-data">
					<Accordion expanded={expandedMainPanel === "parentPanel"} onChange={handleMainChange("parentPanel")} className="mt-3">
						<AccordionSummary className="accordion-header">
							{renderTitleWithIcon("parentPanel", "C.1 Monitoring of Energy consumption")}
						</AccordionSummary>
						<AccordionDetails>
							<Accordion expanded={expandedChild === "panel1"} onChange={handleChildChange("panel1")} className="mt-3">
								<AccordionSummary className="accordion-header">
									{renderTitleWithIcon("panel1", "Conditions of Excemption related to Article 9(2) of regulation (EU) 2015/757")}
								</AccordionSummary>
								<AccordionDetails>
									<FeuConditinsOfExemption
										exemptionConditionsData={data?.c1ExemptionConditions}
										refetchMonitoringData={refetchMonitoringData}
										dropdownData={dropdownData}
										shouldRefetch={expandedChild === "panel1.1"}
										ref={autoSaveForC}
										vesselMstId={vesselMstId}
									/>
								</AccordionDetails>
							</Accordion>
							<Accordion expanded={expandedChild === "panel1.1"} onChange={handleChildChange("panel1.1")} className="mt-3">
								<AccordionSummary className="accordion-header">
									{renderTitleWithIcon("panel1.1", "C.1.1 Methods used to determine fuel consumption of each fuel consumer")}
								</AccordionSummary>
								<AccordionDetails>
									<FeuC11FuelConsumption
										c11FuelConsumption={data?.c11GhgEmissions}
										refetchMonitoringData={refetchMonitoringData}
										dropdownData={dropdownData}
										shouldRefetch={expandedChild === "panel1.2"}
										ref={autoSaveForC11}
										vesselMstId={vesselMstId}
									/>
								</AccordionDetails>
							</Accordion>
							<Accordion expanded={expandedChild === "panel1.2"} onChange={handleChildChange("panel1.2")} className="mt-3">
								<AccordionSummary className="accordion-header">
									{renderTitleWithIcon("panel1.2", "C.1.2 Procedures for determining fuel bunkered and fuel in tanks")}
								</AccordionSummary>
								<AccordionDetails>
									<FeuC12FuelBunkered
										c12FuelTanks={data?.c12FuelTanks}
										refetchMonitoringData={refetchMonitoringData}
										shouldRefetch={expandedChild === "panel1.2"}
										ref={autoSaveForC12}
										vesselMstId={vesselMstId}
									/>
								</AccordionDetails>
							</Accordion>
							{/* C.1.3 Accordion */}
							<Accordion expanded={expandedChild === "panel1.3"} onChange={handleChildChange("panel1.3")} className="mt-3">
								<AccordionSummary className="accordion-header">
									{renderTitleWithIcon(
										"panel1.3",
										"C.1.3 Regular cross-checks between bunkering quantity as provided by BDN and bunkering quantity indicated by on-board measurement:"
									)}
								</AccordionSummary>
								<AccordionDetails>
									<FeuC13BunkerQualityCheck
										c13Bunkering={data?.c13Bunkering}
										refetchMonitoringData={refetchMonitoringData}
										ref={autoSaveForC13}
										vesselMstId={vesselMstId}
									/>
								</AccordionDetails>
							</Accordion>
							<Accordion expanded={expandedChild === "panel2.6"} onChange={handleChildChange("panel2.6")} className="mt-3">
								<AccordionSummary className="accordion-header">
									{renderTitleWithIcon("panel2.6", "C.1.4 Method for determination of fuel density:")}
								</AccordionSummary>
								<AccordionDetails>
									<FeuC14DeterminationOfDensity
										c26MethodForDensity={data?.c14MethodForDensity}
										refetchMonitoringData={refetchMonitoringData}
										dropdownData={dropdownData}
										shouldRefetch={expandedChild === "panel2.6"}
										ref={autoSaveForC14}
										vesselMstId={vesselMstId}
									/>
								</AccordionDetails>
							</Accordion>
							<Accordion expanded={expandedChild === "panel2.7"} onChange={handleChildChange("panel2.7")} className="mt-3">
								<AccordionSummary className="accordion-header">
									{renderTitleWithIcon("panel2.7", "C.1.5 Level of uncertainty associated with fuel monitoring:")}
								</AccordionSummary>
								<AccordionDetails>
									<FeuC15UncertainityLevel
										c27LevelOfUncertainity={data?.c15LevelOfUncertainity}
										refetchMonitoringData={refetchMonitoringData}
										shouldRefetch={expandedChild === "panel2.7"}
										levelOfUncertainities={dropdownData?.levelOfUncertainities}
										monitoringMethod={dropdownData?.monitoringMethodOptions}
										ref={autoSaveForC15}
										vesselMstId={vesselMstId}
									/>
								</AccordionDetails>
							</Accordion>

							<Accordion expanded={expandedChild === "panel1.6"} onChange={handleChildChange("panel1.6")} className="mt-3">
								<AccordionSummary className="accordion-header">
									{renderTitleWithIcon(
										"panel1.6",
										"C.1.6 Procedures for monitoring energy provided by on-shore power supply(ops) (where applicable)"
									)}
								</AccordionSummary>
								<AccordionDetails>
									<FeuC16OnShorePowerSupply
										C16OnShorePowerSupply={data?.c16OnShorePowerSupply}
										refetchMonitoringData={refetchMonitoringData}
										shouldRefetch={expandedChild === "panel1.6"}
										ref={autoSaveForC16}
										vesselMstId={vesselMstId}
									/>
								</AccordionDetails>
							</Accordion>
							<Accordion expanded={expandedChild === "panel1.7"} onChange={handleChildChange("panel1.7")} className="mt-3">
								<AccordionSummary className="accordion-header">
									{renderTitleWithIcon(
										"panel1.7",
										"C.1.7 Procedures for monitoring energy provided by a zero-emission technology(where applicable)"
									)}
								</AccordionSummary>
								<AccordionDetails>
									<FeuC17ZeroEmissions
										c17ZeroEmissionTechnology={data?.c17ZeroEmissionTechnology}
										refetchMonitoringData={refetchMonitoringData}
										shouldRefetch={expandedChild === "panel1.7"}
										ref={autoSaveForC17}
										vesselMstId={vesselMstId}
									/>
								</AccordionDetails>
							</Accordion>
							<Accordion expanded={expandedChild === "panel1.8"} onChange={handleChildChange("panel1.8")} className="mt-3">
								<AccordionSummary className="accordion-header">
									{renderTitleWithIcon(
										"panel1.8",
										"C.1.8 Procedures for monitoring fuel consumption of each fuel consumer when sailing in  ice conditions"
									)}
								</AccordionSummary>
								<AccordionDetails>
									<FeuC18SailingInIce
										c18SailingInIce={data?.c18SailingInIce}
										refetchMonitoringData={refetchMonitoringData}
										shouldRefetch={expandedChild === "panel1.8"}
										ref={autoSaveForC18}
										vesselMstId={vesselMstId}
									/>
								</AccordionDetails>
							</Accordion>
						</AccordionDetails>
					</Accordion>
					<Accordion expanded={expandedMainPanel === "parentPanel2"} onChange={handleMainChange("parentPanel2")} className="mt-3">
						<AccordionSummary className="accordion-header">{renderTitleWithIcon("parentPanel2", "C.2 General procedures for measurements")}
						</AccordionSummary>
						<AccordionDetails>
							<Accordion expanded={expandedChild === 'panel2.1'} onChange={handleChildChange('panel2.1')} className="mt-3">
								<AccordionSummary className="accordion-header">
									{renderTitleWithIcon('panel2.1', 'C.2.1 Description of the measurement instruments involved')}
								</AccordionSummary>
								<AccordionDetails>
									<FeuC21InstrumentsInvolved
										FeuC21InstrumentsInvolved={data?.c21InstrumentMeasurement} refetchMonitoringData={refetchMonitoringData} dropdownData={dropdownData} ref={autoSaveForC21}
										vesselMstId={vesselMstId} />

								</AccordionDetails>
							</Accordion>


							<Accordion expanded={expandedChild === 'panel2.2'} onChange={handleChildChange('panel2.2')} className="mt-3">
								<AccordionSummary className="accordion-header">
									{renderTitleWithIcon('panel2.2', 'C.2.2 Procedures for recording, retrieving, transmitting, and storing information regarding measurements')}
								</AccordionSummary>
								<AccordionDetails>
									<FeuC22ProcedureMeasurements c22FuelTanks={data?.c22RegardingMeasurements} refetchMonitoringData={refetchMonitoringData} shouldRefetch={expandedChild === 'panel2.2'} ref={autoSaveForC22}
									vesselMstId={vesselMstId} />
								</AccordionDetails>
							</Accordion>
							<Accordion expanded={expandedChild === 'panel2.3'} onChange={handleChildChange('panel2.3')} className="mt-3">
								<AccordionSummary className="accordion-header">
									{renderTitleWithIcon('panel2.3', 'C.2.3 Procedures for ensuring quality assurance of measuring equipment')}
								</AccordionSummary>
								<AccordionDetails>
									<FeuC23QualityAssurance c23FuelTanks={data?.c23QualityAsuranceEquipment} refetchMonitoringData={refetchMonitoringData} shouldRefetch={expandedChild === 'panel2.3'} ref={autoSaveForC23}
									vesselMstId={vesselMstId} />
								</AccordionDetails>

							</Accordion>
						</AccordionDetails>
					</Accordion>
					<Accordion expanded={expandedMainPanel === "parentPanel3"} onChange={handleMainChange("parentPanel3")} className="mt-3">
						<AccordionSummary className="accordion-header">{renderTitleWithIcon("parentPanel3", "C.3 Navigation")}</AccordionSummary>
						<AccordionDetails>
							<Accordion expanded={expandedChild === "panel3.1"} onChange={handleChildChange("panel3.1")} className="mt-3">
								<AccordionSummary className="accordion-header">
									{renderTitleWithIcon("panel3.1", "C.3.1 Procedures for determining and recording the list of voyages")}
								</AccordionSummary>
								<AccordionDetails>
									<FeuC31ListOfVoyages
										c31VoyagesList={data?.c31VoyagesList}
										refetchMonitoringData={refetchMonitoringData}
										dropdownData={dropdownData}
										shouldRefetch={expandedChild === "parentPanel"}
										ref={autoSaveForC31}
										vesselMstId={vesselMstId}
									/>
								</AccordionDetails>
							</Accordion>
							<Accordion expanded={expandedChild === "panel3.2"} onChange={handleChildChange("panel3.2")} className="mt-3">
								<AccordionSummary className="accordion-header">
									{renderTitleWithIcon("panel3.2", "C.3.2  Procedures for determining and recording the Distance travelled")}
								</AccordionSummary>
								<AccordionDetails>
									<FeuC32DistanceTravelled
										c32DistanceTravelled={data?.c32DistanceTravelled}
										refetchMonitoringData={refetchMonitoringData}
										dropdownData={dropdownData}
										shouldRefetch={expandedChild === "panel1.2"}
										ref={autoSaveForC32}
										vesselMstId={vesselMstId}
									/>
								</AccordionDetails>
							</Accordion>
							<Accordion expanded={expandedChild === "panel3.3"} onChange={handleChildChange("panel3.3")} className="mt-3">
								<AccordionSummary className="accordion-header">
									{renderTitleWithIcon(
										"panel3.3",
										"C.3.3 Procedures for determining and recording the date, time and position when entering and leaving the ice conditions, the distance travelled when sailing in ice conditions"
									)}
								</AccordionSummary>
								<AccordionDetails>
									<FeuC33DistanceTravelledInIce
										c33DistanceTravelledInIce={data?.c33DistanceTravelledInIce}
										refetchMonitoringData={refetchMonitoringData}
										shouldRefetch={expandedChild === "panel1.2"}
										ref={autoSaveForC33}
										vesselMstId={vesselMstId}
									/>
								</AccordionDetails>
							</Accordion>

							<Accordion expanded={expandedChild === "panel3.4"} onChange={handleChildChange("panel3.4")} className="mt-3">
								<AccordionSummary className="accordion-header">
									{renderTitleWithIcon("panel3.4", "C.3.4  Procedures for determining and recording the time spent at sea and at berth")}
								</AccordionSummary>
								<AccordionDetails>
									<FeuC34SeaBerthTimeProcedures
										c34SeaBerthTimeProcedures={data?.c34RegardingTimeSpent}
										refetchMonitoringData={refetchMonitoringData}
										shouldRefetch={expandedChild === "panel2.7"}
										ref={autoSaveForC34}
										vesselMstId={vesselMstId}
									/>
								</AccordionDetails>
							</Accordion>
						</AccordionDetails>
					</Accordion>
				</form>
			</FormProvider>
		</div>
	);
};

export default FeuActivityData;
